module.exports = __webpack_public_path__ + "static/media/site_resources_clinical_trial_info.6eade31a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/mi-app/siteResources/assets/site_resources_clinical_trial_info.jpeg
// module id = 1130
// module chunks = 1